import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GetAllServers } from "../../Api/Panel/GetAllServers";

export default function Pricing() {
  const [pricing, setPricing] = useState([]);

  const Get = async () => {
    const { data } = await GetAllServers();
    setPricing(data);
  };

  useEffect(() => {
    Get();
  }, []);

  return (
    <>
      <div className="bg-gray-900">
        <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
          <div className="mx-auto max-w-screen-md text-center mb-8 lg:mb-12">
            <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-white">
              Choose a plan that works for you
            </h2>
            <p className="mb-5 font-light  sm:text-xl text-gray-400">
              By subscribing to PayCoLife plans, you agree to PayCoLife's Terms
              of Service. Note: PayCoLife's privacy policy describes how data is
              used on this service.
            </p>
          </div>

          <div className="mb-5 space-y-8 lg:grid lg:grid-cols-4 sm:gap-6 xl:gap-10 lg:space-y-0">
            {pricing?.map((el, i) => {
              return (
                <div
                  key={i}
                  className="flex flex-col p-6 mx-auto max-w-lg text-center  rounded-lg border border-gray-100 shadow  xl:p-8 bg-gray-800 text-white"
                >
                  <div className="inline-flex justify-center items-center">
                    <h3 className="mb-4 text-2xl font-semibold">{el.title}</h3>
                    <h3 className=" pl-1 mb-4 text-sm font-semibold">
                      ( {el.roleType} )
                    </h3>
                  </div>
                  <p className="font-light sm:text-lg text-gray-400">
                    {el.desc}
                  </p>
                  <div className="flex justify-center items-baseline my-8">
                    <span className=" text-3xl font-extrabold">
                      {el.bigPrice}
                    </span>
                    <span className=" text-xl font-extrabold">
                      {el.smallPrice}
                    </span>
                    <span className="text-sm text-gray-400">{el.month}</span>
                  </div>
                  <ul className="mb-8 space-y-4 text-left">
                    {el?.features.map((ele, index) => (
                      <li
                        key={index}
                        className="flex items-center space-x-3 h-10"
                      >
                        <svg
                          className="flex-shrink-0 w-5 h-5  text-green-400"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                        <span>{ele}</span>
                      </li>
                    ))}
                  </ul>
                  <Link
                    to={el.href}
                    className="text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center  bg-[#3742fa] p-2bg-[#3742fa] hover:bg-[#5352ed] p-2 focus:ring-primary-900"
                  >
                    Get started
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
